import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddPlusDoubleUpOutline = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_88_1157)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M3.33333 4H3.99999V10C3.99999 11.1067 4.89333 12 6 12H12V12.6667C12 13.7733 11.1067 14.6667 10 14.6667H3.33333C2.22666 14.6667 1.33333 13.7733 1.33333 12.6667V6C1.33333 4.89333 2.22666 4 3.33333 4Z",
				stroke: "currentColor",
				strokeWidth: 1.2,
				strokeMiterlimit: 10,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.6667 3.33333V10C14.6667 11.1067 13.7733 12 12.6667 12H6C4.89333 12 4 11.1067 4 10V3.33333C4 2.22667 4.89333 1.33333 6 1.33333H12.6667C13.7733 1.33333 14.6667 2.22667 14.6667 3.33333Z",
				stroke: "currentColor",
				strokeWidth: 1.2,
				strokeMiterlimit: 10,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.33333 10V3.33333",
				stroke: "currentColor",
				strokeWidth: 1.2,
				strokeMiterlimit: 10,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6 6.66667H12.6667",
				stroke: "currentColor",
				strokeWidth: 1.2,
				strokeMiterlimit: 10,
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_88_1157",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgAddPlusDoubleUpOutline;
